import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

export default styled(Link)`
  ${({ theme }) => css`
    color: ${theme.colors.primaryDark};
    text-decoration: none;
    font-weight: ${theme.fonts.weights.bold};
  `}
`;
